import { createSlice } from "@reduxjs/toolkit";

const adminSlice = createSlice({
  name: "admin",
  initialState: {
    adminPayments: [],
    driverPayments: [],
    pendingTransactions: [],
    sellers: [],
    isLoading: false,
    search: "",
    pagination: {
      page: 1,
      totalPages: 1,
      perPage: 10,
    },
  },
  reducers: {
    setAdminPayments: (state, action) => { state.adminPayments = action.payload; },
    setDriverPayments: (state, action) => { state.driverPayments = action.payload; },
    setPendingTransactions: (state, action) => { state.pendingTransactions = action.payload; },
    setSellerList: (state, action) => { state.sellers = action.payload; },
    setIsLoading: (state, action) => { state.isLoading = action.payload; },
    setSearch: (state, action) => { state.search = action.payload; },
    setPagination: (state, action) => { state.pagination = { ...state.pagination, ...action.payload }; },
  },
});

export const {
  setAdminPayments,
  setDriverPayments,
  setPendingTransactions,
  setSellerList,
  setIsLoading,
  setSearch,
  setPagination,
} = adminSlice.actions;

export default adminSlice.reducer;
